import React from "react";
import { motion } from "framer-motion";

// Line-by-line masked reveal. Pass an array of lines (strings).
export const RevealLines = ({ lines = [], className = "", delay = 0, stagger = 0.12 }) => {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-line">
          <motion.span
            style={{ display: "block" }}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.1,
              ease: [0.16, 1, 0.3, 1],
              delay: delay + i * stagger,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className = "", stagger = 0.1 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{ show: { transition: { staggerChildren: stagger } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 40 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
    }}
  >
    {children}
  </motion.div>
);
